import type { FormEvent } from 'react'

export function formDataFromEvent(e: FormEvent<HTMLFormElement>) {
	return Object.fromEntries([...new FormData(e.currentTarget).entries()])
}
